export default {
  avenants_pending: false,
  avenants: [],
  avenants_refresh_pending: false,
  lastModified: null
}
